import { Star } from "lucide-react";

const quotes = [
  {
    body: "The density on my Deep Curl Goddess is unreal. No styling needed, it's already laid.",
    name: "Amara O.",
    meta: "Deep Curl Goddess · 14\"",
  },
  {
    body: "My Honey Blonde arrived softer than I expected and the lace melted right in. So many compliments.",
    name: "Jasmine K.",
    meta: "Honey Blonde Body Wave · 16\"",
  },
  {
    body: "I've tried five brands. Kay's is the only one that still looks new after two months of daily wear.",
    name: "Renée B.",
    meta: "Luxe Silk Straight · 16\"",
  },
];

const Testimonials = () => {
  return (
    <section data-testid="testimonials" className="border-b border-border/60 bg-secondary/30">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 lg:py-24">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-[#B8935F] font-medium mb-2">
              Customer love
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl leading-tight text-foreground">
              Words from the <em className="italic font-medium">inner circle</em>.
            </h2>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <div className="flex" aria-label="5 out of 5 stars">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={i}
                  className="w-4 h-4 fill-[#B8935F] text-[#B8935F]"
                />
              ))}
            </div>
            <span className="text-foreground/80 font-medium">4.9</span>
            <span className="text-muted-foreground">· 237 reviews</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {quotes.map((q, i) => (
            <figure
              key={q.name}
              data-testid={`testimonial-${i}`}
              className="bg-[hsl(var(--background))] border border-border/70 p-6 lg:p-8 rounded-sm flex flex-col justify-between fade-up"
            >
              <div>
                <div className="flex mb-4" aria-hidden>
                  {Array.from({ length: 5 }).map((_, j) => (
                    <Star
                      key={j}
                      className="w-3.5 h-3.5 fill-[#B8935F] text-[#B8935F]"
                    />
                  ))}
                </div>
                <blockquote className="font-serif text-xl lg:text-[22px] leading-snug text-foreground">
                  "{q.body}"
                </blockquote>
              </div>
              <figcaption className="mt-6 pt-5 border-t border-border/70">
                <div className="text-sm text-foreground font-medium">{q.name}</div>
                <div className="text-xs text-muted-foreground mt-0.5">{q.meta}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
